import { MONOLITH_API_PREFIX } from 'src/consts';
import { GET, PUT } from 'src/utils/request';
import { CLIENT_ID } from 'src/consts';

export function getSearchMealUrl(restaurantId) {
  return `${MONOLITH_API_PREFIX}/api/pos/v4/restaurants/${restaurantId}/meal_instances/search`;
}

export function getAllMealPrototypes(restaurantId) {
  return GET(
    `${MONOLITH_API_PREFIX}/api/pos/v4/restaurants/${restaurantId}/meal_prototypes`,
    {},
    {
      headers: {
        'client-id': CLIENT_ID,
        'service-region-id': 1,
      },
      parseAsJSONApi: true,
    }
  );
}

export function getMenuInfo({ restaurantId, menuId }) {
  return GET(
    `${MONOLITH_API_PREFIX}/api/restaurant/v2/restaurants/${restaurantId}/menus/${menuId}`,
    {},
    {
      headers: {
        'client-id': CLIENT_ID,
        'service-region-id': 1,
      },
      parseAsJSONApi: true,
    }
  );
}

export function updateMenuCacheInfo({ restaurantId, menuId, ...payload }) {
  return PUT(`${MONOLITH_API_PREFIX}/api/restaurant/v2/restaurants/${restaurantId}/menus/${menuId}`, payload, {
    headers: {
      'client-id': CLIENT_ID,
      'service-region-id': 1,
    },
  });
}

export function searchMeals({ page = 1, pageSize = 50, searchTerm = '', restaurantId }) {
  return GET(
    getSearchMealUrl(restaurantId),
    {
      page,
      page_size: pageSize,
      search_term: searchTerm,
    },
    {
      headers: {
        'client-id': CLIENT_ID,
        'service-region-id': 1,
      },
      parseAsJSONApi: true,
    }
  );
}
